import config from 'constants/apiConfig';
import axios from 'axios';


import {
  FETCH_CORE_COMPONENTS_REQUEST,
  FETCH_CORE_COMPONENTS_SUCCESS,
  FETCH_CORE_COMPONENTS_ERROR,
  UPSERT_CORE_COMPONENT_REQUEST,
  UPSERT_CORE_COMPONENT_SUCCESS,
  UPSERT_CORE_COMPONENT_ERROR,
  DELETE_CORE_COMPONENT_REQUEST,
  DELETE_CORE_COMPONENT_SUCCESS,
  DELETE_CORE_COMPONENT_ERROR,
  UPDATE_CURRENT_AOR_REQUEST,
  UPDATE_CURRENT_AOR_SUCCESS,
  UPDATE_CURRENT_AOR_ERROR,
} from 'constants/ai2fp-action-types';
import { toast } from 'react-toastify';
import { noAutoClose } from 'assets/data/config';
import { endLoading } from 'reducers/loading/loading.action';

function fetchCoreComponentsRequest() {
  return {
    type: FETCH_CORE_COMPONENTS_REQUEST,
  };
}

function fetchCoreComponentsSuccess(data) {
  return {
    type: FETCH_CORE_COMPONENTS_SUCCESS,
    payload: data,
  };
}

function fetchCoreComponentsError(error) {
  const errorMessage =
    'fetchCoreComponentsError\n\n' +
    ((!!error &&
      !!error.message &&
      typeof error.message === 'string' &&
      error.message) ||
      '') +
    '\n\nIf you continue to experience this error, contact support@disastertech.com';
  console.error(errorMessage);
  toast.error(errorMessage, noAutoClose);
  return {
    type: FETCH_CORE_COMPONENTS_ERROR,
  };
}

export const fetchCoreComponents = (group_guid) => {
  return (dispatch) => {
    dispatch(fetchCoreComponentsRequest());
    return axios(config.apiGateway.fetchCoreComponents, {
      method: 'POST',
      data: JSON.stringify({
        group_guid,
      }),
    })
      .then((response) => {
        const data = response.data || {};
        dispatch(fetchCoreComponentsSuccess(data));
      })
      // .catch((error) => {
      //   dispatch(fetchCoreComponentsError(error));
      // });
  };
};

function upsertCoreComponentRequest() {
  return {
    type: UPSERT_CORE_COMPONENT_REQUEST,
  };
}

function upsertCoreComponentSuccess(data) {
  return {
    type: UPSERT_CORE_COMPONENT_SUCCESS,
    payload: data,
  };
}

function upsertCoreComponentError(error) {
  const errorMessage =
    'upsertCoreComponentError\n\n' +
    ((!!error &&
      !!error.message &&
      typeof error.message === 'string' &&
      error.message) ||
      '') +
    '\n\nIf you continue to experience this error, contact support@disastertech.com';
  console.error(errorMessage);
  toast.error(errorMessage, noAutoClose);
  return {
    type: UPSERT_CORE_COMPONENT_ERROR,
  };
}

export const upsertCoreComponent = (cc) => {
  return (dispatch) => {
    dispatch(upsertCoreComponentRequest());
    return axios(config.apiGateway.upsertCoreComponent, {
      method: 'POST',
      data: JSON.stringify({
        cc,
      }),
    })
      .then((response) => {
        const data = response.data || {};
        dispatch(fetchCoreComponents(cc.group_guid));
        dispatch(upsertCoreComponentSuccess(data));
        // toast.success('Upsert Core Components successful', {
        //   autoClose: 2000,
        // });
      })
      .catch((error) => {
        dispatch(upsertCoreComponentError(error));
      });
  };
};


function deleteCoreComponentRequest() {
  return {
    type: DELETE_CORE_COMPONENT_REQUEST,
  };
}

function deleteCoreComponentSuccess(data) {
  return {
    type: DELETE_CORE_COMPONENT_SUCCESS,
    payload: data,
  };
}

function deleteCoreComponentError(error, type) {
  // const errorMessage =
  // 'deleteCoreComponentError\n\n' +
  // ((!!error &&
  //   !!error.message &&
  //   typeof error.message === 'string' &&
  //   error.message) ||
  //   '') +
  // '\n\nIf you continue to experience this error, contact support@disastertech.com';
  let errorMessage;
  if (error.response['data'].ERROR.includes('Foreign Key Violation')) {
    errorMessage = `We can't delete this ${type}, because this is associated with other functionalities`;
  } else {
    errorMessage =
      'deleteCoreComponentError\n\n' +
      ((!!error &&
        !!error.message &&
        typeof error.message === 'string' &&
        error.message) ||
        '') +
      '\n\nIf you continue to experience this error, contact support@disastertech.com';
  }

  console.error(errorMessage);
  toast.error(errorMessage, noAutoClose);
  return {
    type: DELETE_CORE_COMPONENT_ERROR,
  };
}

export const deleteCoreComponent = (cc) => {
  return (dispatch) => {
    dispatch(deleteCoreComponentRequest());
    return axios(config.apiGateway.deleteCoreComponent, {
      method: 'POST',
      data: JSON.stringify({
        cc,
      }),
    })
      .then((response) => {
        const data = response.data || {};
        dispatch(deleteCoreComponentSuccess(data));
        dispatch(fetchCoreComponents(cc.group_guid));
        // toast.success('Delete Core Components successful', {
        //   autoClose: 2000,
        // });
      })
      .catch((error) => {
        dispatch(deleteCoreComponentError(error, cc.cc_type));
        dispatch(endLoading());
      });
  };
};

function updateCurrentAORRequest() {
  return {
    type: UPDATE_CURRENT_AOR_REQUEST,
  };
}

function updateCurrentAORSuccess(aor) {
  return {
    type: UPDATE_CURRENT_AOR_SUCCESS,
    payload: aor,
  };
}

function updateCurrentAORError(error) {
  const errorMessage =
    'updateCurrentAORError\n\n' +
    ((!!error &&
      !!error.message &&
      typeof error.message === 'string' &&
      error.message) ||
      '') +
    '\n\nIf you continue to experience this error, contact support@disastertech.com';
  console.error(errorMessage);
  toast.error(errorMessage, noAutoClose);
  return {
    type: UPDATE_CURRENT_AOR_ERROR,
  };
}

export const updateCurrentAOR = (aor) => {
  return (dispatch, getState) => {
    dispatch(updateCurrentAORRequest());
    const { currently_selected } = getState().app.user;
    const new_currently_selected = {
      ...currently_selected,
      aor_id: !!aor && aor.id,
    };
    return axios(config.apiGateway.updateCurrentlySelected, {
      method: 'POST',
      data: JSON.stringify({
        currently_selected: new_currently_selected,
      }),
    })
      .then(() => {
        dispatch(updateCurrentAORSuccess(aor));
        // toast.success('Update Currently Selected successful', {
        //   autoClose: 2000,
        // });
      })
      .catch((error) => {
        dispatch(updateCurrentAORError(error));
      });
  };
};
